/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import CampaignModel from 'cio/models/campaign';

interface VisualWorkflowBuilderV2SingleMoveWarningModalArgs {
  campaign: CampaignModel;
  actionBeingMoved: ActionModel;
  singleMoveDelayActionIds: string[];
  singleMoveTotalDelaySubjectsCount: number;
  confirmMove: () => unknown;
  cancelMove: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class VisualWorkflowBuilderV2SingleMoveWarningModal extends Component<VisualWorkflowBuilderV2SingleMoveWarningModalArgs> {}
